export const ROUTE_BASE_URL = process.env['BASE_URL']

export const routes = {
  login: {
    path: '/login',
  },
  signup: {
    path: '/signup',
  },
  forgotPassword: {
    path: '/forgot-password',
  },
  resendConfirmUserEmail: {
    path: '/resend-email-confirmation',
  },
  userConfirm: {
    path: '/user-confirm',
  },
  invitationConfirm: {
    path: '/invitation-confirm',
  },
  resetPassword: {
    path: '/reset-password',
  },
  /* test: {
    path: '/test',
    makeUrl: (id: number): string => `/test/${id}`,
  },*/
}

export const protectedRoutes = {
  dashboard: {
    path: '/',
  },
  profile: {
    path: '/profile',
  },
  userRegistration: {
    path: '/registration/user',
  },
  documentsRegistration: {
    path: '/registration/documents',
  },
  sponsorRequestShow: {
    path: '/sponsor-request/:sponsorRequestId',
    makeUrl: (sponsorRequestId: number): string =>
      `/sponsor-request/${sponsorRequestId}`,
  },
  sponsorRequestCreate: {
    path: '/sponsor-request/create',
  },
  sponsorRequestEdit: {
    path: '/sponsor-request/:sponsorRequestId/edit',
    makeUrl: (sponsorRequestId: number): string =>
      `/sponsor-request/${sponsorRequestId}/edit`,
  },
}

// Utils

export const getPublicRoutes = (): string[] =>
  Object.values(routes).map((route) => route.path)

export const getProtectedRoutes = (): string[] =>
  Object.values(protectedRoutes).map((route) => route.path)
